import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { WorkingHours } from 'src/app/models/persona/profile/workingHours';
import { ToastService } from 'src/app/services/toast.service';
import { FormArray, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { HttpClient } from '@angular/common/http';
import { scrollToFirstInvalidControl } from 'src/app/utils/scrollToFirstInvalidControl';
import { ApcSectionAnchorsComponent } from '../apc-section-anchors/apc-section-anchors.component';
import { clearErrors } from 'src/app/utils/clearFormErrors';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { BudgetService } from '../../user/order/budget/service/budget.service';

@Component({
  selector: 'apc-multi-forms',
  templateUrl: './multi-forms.component.html',
  styleUrls: ['./multi-forms.component.scss'],
  providers: [BudgetService],
})
export class MultiFormsComponent {
  public data: WorkingHours[] = [];
  //public form: UntypedFormGroup;
  @Input() forms: FormArray<any>;
  public submitFailed = false;
  public allCollapsed = false;
  public canCollapse: boolean = false;
  private firstLoad: boolean = true;
  @Output() addTitleToCollapsableEvent = new EventEmitter<any>();
  @Output() calculateTotalHoursPercentageEvent = new EventEmitter<any>();
  @Output() fillFullTimeEvent = new EventEmitter<any>();
  @Output() toggleEdit = new EventEmitter<any>();
  @Output() saveSuccess = new EventEmitter<any>();
  @Output() newProjectEvent = new EventEmitter<any>();
  @Output() newBudgetFillEmmiter = new EventEmitter<any>();
  @Output() rightIconEvent = new EventEmitter<any>();
  @Input() public newEmptyForm: any;
  @Input() public newDataForm: any;
  @Input() public getData: Function;
  @Input() public getDataSearch: Function;
  @Input() public createData: Function;
  @Input() public updateData: Function;
  @Input() public deleteData: Function;
  @Input() public user_id: string;
  @Input() public showHeaderIcon: boolean = true;
  @Input() public showRowIcon: boolean = true;

  @Input() formTemplate: TemplateRef<any>;
  @Input() header: string;
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() icon: string = '';
  @Input() rightIcon: string = '';

  @Input() openedId: string = null;
  @ViewChild(ApcSectionAnchorsComponent) sectionAnchors: ApcSectionAnchorsComponent;
  @ViewChild('toggle') toggle: ElementRef;
  public workingdays;
  public recordsCount;
  public recordQuery;
  public page = 1;
  public orderId;
  public searchValueBudget: string = '';
  public budgets = [];
  public isLoading: boolean = false;
  public isOpen: boolean = false;

  constructor(
    private router: Router,
    public http: HttpClient,
    private toastService: ToastService,
    public cdr: ChangeDetectorRef,
    private el: ElementRef,
    private budgetService: BudgetService
  ) {
  }

  async ngOnInit() {
    var urlFragments = this.router.url.split('/');
    this.orderId = this.router.url.split('/')[2];
    var openedId = urlFragments[urlFragments.findIndex((el) => el === 'budget') + 1];
    
    this.initData(1,openedId);
  }

  async initData(page, openedBudget = '') {
    console.log(this.section);
    this.page = page;
    this.data = [];
    while (this.forms.length) {
      this.forms.removeAt(0);
    }
    if(this.section=="budget" && this.searchValueBudget.length > 2){
      this.data = await this.getDataSearch(this.orderId, page,this.searchValueBudget);
    }
    else{
      this.data = await this.getData(this.user_id, page, openedBudget);
    }
    if(this.data['page']){
      console.log("SI paginazione "+this.section);
      this.recordsCount = this.data['totalBudgets'];
      this.recordQuery = this.data['page']['totalElements'];
      this.data['page']['content'].forEach((el) => {
        this.forms.push(this.newDataForm(el));
      });
    }
    else{
      console.log("NO paginazione "+this.section);
      this.recordsCount = this.data.length;
      this.data.forEach((el) => {
        this.forms.push(this.newDataForm(el));
      });
    }
    this.addTitleToCollapsable(false);
    this.closeAll();
    if (this.openedId) {
      this.toggleElement(this.openedId, true);
    }
    this.calcTotalHours(false);
    if(openedBudget){
      this.seacrhBudgetName();
      this.searchValueBudget = openedBudget;

    }
  }

  async calcTotalHours(loadAll: boolean) {
    if (loadAll) {
      this.data = await this.getData(this.user_id);
    }
    if (this.section === 'product') {
      var totalHours = 0;
      this.data.forEach((item: any) => {
        totalHours += item.quantity;
      });
      this.workingdays = this.reformatProductSingleHours(totalHours);
    }
    if (this.section === 'budget') {
      var totalHours = 0;
      if(this.data['page']['content']){
        totalHours = this.data['totalOrdered'];
      }
      else{
        this.data.forEach((item: any) => {
          item.budgetProducts = this.sortProducts(item.budgetProducts);
          item.budgetProducts.forEach((budget) => {
            totalHours += budget.quantity;
          });
        });
      }

      this.workingdays = this.reformatProductSingleHours(totalHours);
      return this.data;
    }
  }

  sortProducts(item){
    return item.sort(function(a, b){
      if(a.product.code < b.product.code){
        return 1
      }else if(a.product.code > b.product.code){
        return -1;
      }else{
        return 0;
      }
    });

  }

  reformatProductSingleHours(hours: number) {
    return hours && Number(hours) > 0
      ? '[ ' + Number(hours).toFixed(2) + 'h | ' + Number(hours / 8).toFixed(2) + 'd ]'
      : null;
  }

  toggleAll() {
    this.allCollapsed = !this.allCollapsed;
    this.firstLoad = true;
    this.forms.controls.forEach((item: any) => {
      item.isCollapsed = this.allCollapsed;
    });
  }

  closeAll() {
    this.allCollapsed = true;
    this.firstLoad = true;
    this.forms.controls.forEach((item: any) => {
      item.isCollapsed = this.allCollapsed;
    });
  }

  setToggle() {
    this.toggleOthers();
    let canToggle = Object.values(this.forms.controls).filter((value: any) => value.isCollapsed === true).length === 3;
    if (!canToggle) {
      this.canCollapse = true;
    } else {
      this.allCollapsed = true;
      this.canCollapse = false;
    }
  }

  toggleOthers() {
    !this.allCollapsed &&
      this.forms.controls.forEach((item: any) => {
        if (item.value.identifier === this.openedId && this.firstLoad) {
          this.firstLoad = false;
          this.toggleElement(item.value.identifier, false);
        } else if (item.value.identifier === this.openedId && !this.firstLoad) {
          item.isCollapsed = true;
          this.allCollapsed = true;
        }
      });
  }

  toggleElement(elemId: string, firstLoad: boolean) {
    this.openedId = elemId;
    var fragments = window.location.pathname.split('/');
    var sectionIndex;

    fragments.forEach((f, i) => {
      if (f == this.section) {
        sectionIndex = i;
      }
    });
    // toggle urls between same multisection
    if (window.location.pathname.includes(this.subsection) && !firstLoad) {
      let idToReplace = fragments.findIndex((el) => el === this.subsection) + 1;
      fragments[idToReplace] = elemId;
    }
    // check if we were on another multisection on current page
    else if (fragments.length >= sectionIndex + 1 && !firstLoad) {
      fragments[sectionIndex + 2] = this.subsection;
      fragments[sectionIndex + 3] = elemId;
    } else if (!firstLoad) {
      fragments.push(this.subsection);
      fragments.push(elemId);
    }
    window.history.replaceState({}, '', fragments.join('/'));
    if (window.location.pathname.includes(this.subsection)) {
      this.forms.controls.forEach((item: any) => {
        if (item.value.identifier === elemId) {
          item.isCollapsed = !item.isCollapsed;
        } else {
          item.isCollapsed = true;
        }
      });
    }
  }

  addNewSection() {
    // going to check if we already have some epty form
    let emptyAlreadyExists = false;
    this.forms.controls.forEach((item) => {
      if (!item.value.identifier) {
        emptyAlreadyExists = true;
      }
    });
    // add new form only if we dont have any empty form initialized
    if (!emptyAlreadyExists) {
      const newForm = this.forms.push(this.newEmptyForm());
      this.forms.controls.forEach((formControl: any) => {
        // if the form is new/being created, put it to edit mode
        if (!formControl.value.identifier) {
          formControl.editForm = true;
          this.newSectionBlanket();
        }
      });
    }
  }

  async saveForm(form: any) {
    try {
      if (form.valid || this.submitFailed) {
        let newItem = null;
        // if id exists it means we are editing
        if (form.value.identifier) {
          var isNewItem = false;
          newItem = await this.updateData(this.user_id, form.value);
          form.patchValue(newItem);
          form.updateValueAndValidity();
          form.markAsPristine();
        }
        // creating new
        else {
          var isNewItem = true;
          newItem = await this.createData(this.user_id, form.value);
          form.patchValue(newItem);
          form.updateValueAndValidity();
          form.markAsPristine();
        }
        form.editForm = false;
        this.addTitleToCollapsable();
        this.toastService.showSuccess('Operation success!');
        clearErrors(form);
        form.markAsUntouched();
        if(isNewItem){
          this.redirect(newItem['identifier']);
        }
        document.getElementById('blanket').classList.add('d-none');
        document.querySelector('.blanket-active').classList.remove('blanket-active');
        this.saveSuccess.emit(true);
        this.calcTotalHours(true);
      } else {
        this.toastService.showError('Operation error!');
        form.markAsPristine();
        form.markAllAsTouched();
      }
    } catch (e) {
      clearErrors(form);
      this.submitFailed = true;
      this.toastService.showError('Operation error!');
      if (e.validationErrors.length > 0) {
        form.markAsPristine();
        checkForValidationErrors(e, form);
        scrollToFirstInvalidControl(this.el);
      }
    }
  }

  async cancelForm(item) {
    // if canceling form that exists (edit form), fetch old form data and replace that data with current data that we want to cancel
    if (item.value.identifier) {
      const index = this.forms.controls.findIndex((p) => p.value.identifier === item.value.identifier);
      this.data = await this.getData(this.user_id);
      let oldHour = this.data.find((h) => h.identifier == item.value.identifier);
      let form = this.newDataForm(oldHour);
      form.editForm = false;
      this.forms.controls[index] = form;
      this.addTitleToCollapsable();
    }
    // if canceling form that does not exist (new form), just remove it from the list
    else {
      this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== null);
    }

    // Emit undo EditMode Enabled
    this.onEdit(item, false);
  }

  async cloneForm(item) {
    this.data = await this.getData(this.user_id);
    let hoursToClone = this.data.find((h) => h.identifier == item.value.identifier);
    // copying object, removing references to the object we copied from
    let clonedHours = JSON.parse(JSON.stringify(hoursToClone));
    // puting id to null beacuse it is a new form
    clonedHours.identifier = null;
    // pushing to the forms list
    this.forms.push(this.newDataForm(clonedHours));
    this.addTitleToCollapsable();
    // opening new form for editing mode
    this.forms.controls.forEach((item: any) => {
      // if the form is new/being created, put it to edit mode
      if (!item.value.identifier) {
        item.editForm = true;
        this.newSectionBlanket();
      }
    });
  }

  async delete(subsectionIdentifier: string) {
    await this.deleteData(this.user_id, subsectionIdentifier);
    this.calcTotalHours(true);
    this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== subsectionIdentifier);
    this.resetIds();
    this.toastService.showSuccess('Operation success!');
  }

  resetIds() {
    this.forms.controls.forEach((el, index) => {
      if(document.getElementById(el.value.identifier)) {
      let row : any = document.getElementById(el.value.identifier);
       row.getElementsByTagName("div")[0].id = this.subsection + '-row-' + index;
      }
    })
  }

  addTitleToCollapsable(recalculateHour = true) {
    this.resetIds();
    this.addTitleToCollapsableEvent.emit(this.forms);
    if(recalculateHour)
      this.calcTotalHours(true);
  }

  calculateTotalHoursPercentage(form: UntypedFormGroup) {
    this.calculateTotalHoursPercentageEvent.emit();
  }

  fillFullTime(item) {
    this.fillFullTimeEvent.emit(item);
    item.markAsDirty();
  }

  toggleExpandedClass(toggle) {
    let toggleEl: HTMLDivElement = <HTMLDivElement>this.toggle.nativeElement;
    if (toggle) {
      toggleEl.classList.remove('toggle-shrinked');
      toggleEl.classList.add('toggle-expanded');
    } else {
      if (this.allCollapsed) {
        toggleEl.classList.remove('toggle-expanded');
        toggleEl.classList.add('toggle-shrinked');
      }
    }
  }

  onEdit(item, event) {
    this.manageBlanket(item.value.identifier, event);
    item.editForm = event;
  }

  public editModeArray = [];
  manageBlanket(itemId: string, isEdit: boolean) {
    var rowId;
    if (itemId) {
      rowId = this.forms.controls.findIndex((control) => control.value.identifier == itemId);
    } else {
      rowId = this.forms.controls.length - 1;
    }
    if (isEdit === false) {
      this.editModeArray = this.editModeArray.filter((obj) => obj !== isEdit);
      document.getElementById('blanket').classList.add('d-none');
      document.getElementById(this.subsection + `-row-${rowId}`)?.classList.remove('blanket-active');
    } else if (isEdit === true) {
      this.editModeArray.push(itemId);
      document.getElementById('blanket').classList.remove('d-none');
      document.getElementById(this.subsection + `-row-${rowId}`)?.classList.add('blanket-active');
    }
  }

  newSectionBlanket() {
    setTimeout(() => {
      document.getElementById('blanket').classList.remove('d-none');
      const newElementId = this.subsection + `-row-${this.forms.controls.length - 1}`;
      document.getElementById(newElementId).classList.add('blanket-active');
      document.getElementById(newElementId).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
    }, 400);
  }

  newProduct(item) {
    //item.editForm = true;
    if (!item.controls.budgetProducts.value) {
      item.controls.budgetProducts.value = [];
    }
    item.controls.budgetProducts.value.push({ identifier: null, product: null, quantity: null });
    setTimeout(() => {
      var elId = 'new-budget-product';
      document.getElementById(elId).getElementsByTagName('button')[0].click();
      document.getElementById(elId).scrollIntoView({ behavior: 'smooth' });
    }, 200);
  }

  newProject(id: string, project: any) {
    this.newProjectEvent.emit({ budgetId: id, projectId: project ? project.identifier : null });
  }

  newBudgetFill(id: string) {
    this.newBudgetFillEmmiter.emit(id);
  }

  returnDeleteText(projectName) {
    if (projectName)
      return (
        'Project <b>' +
        projectName +
        '</b> is currently linked to this budget.<br/>Are you sure you want to delete this budget?<br/>The delete operation will automatically unlink the project.'
      );
    return 'Are you sure to delete this item?';
  }

  pageChange(){    
    this.initData(this.page);
  }

  seacrhBudgetName(){
    this.isOpen = true;
    setTimeout(() => document.getElementById('quick-search-budget').focus(), 200);
  }

  closeSearchBudget(){
    this.isOpen = false;
    this.budgets = [];
    this.searchValueBudget = '';
    this.redirect('');
  }

  redirect(budgetId: string) {
    let finalUrl ='order/' + this.orderId;
    if(budgetId){
      finalUrl += '/budget/' + budgetId;
    }    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([finalUrl]);

    this.searchValueBudget = '';
    this.budgets = [];
    this.isOpen = false;
  }

  search(event){
    if(event.keyCode === 13 && this.searchValueBudget.length > 2){
      this.isLoading = true;
      this.budgets = [];
      this.initData(1);
    }
    else {
      this.budgets = [];
      this.isLoading = false;
    }
  }
}
